import { ButtonProps, Button as MuiButton, useTheme } from "@mui/material";

const Button = (props: ButtonProps) => {
  const theme = useTheme();

  if (theme.name === "inline") {
    return (
      <button
        className={props.className}
        disabled={props.disabled}
        onClick={props.onClick}
      >
        {props.children}
      </button>
    );
  }

  return <MuiButton {...props} />;
};

export default Button;
